import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Home.css";
import * as icons from "../icons/Icons";
import cv from "../cv/CV_Jaylano_van_der_veen.pdf";

const skills = [

  { name: "C#", startdate: "08-24-2023", icon: icons.csharp, color: "#9B4F96" },
  { name: "JavaScript", startdate: "08-24-2023", icon: icons.javascript, color: "#F7DF1E" },
  { name: "HTML", startdate: "08-24-2023", icon: icons.html, color: "#E34F26" },
  { name: "SQL", startdate: "02-24-2024", icon: icons.sql, color: "#336791" },
  { name: "Git", startdate: "02-24-2024", icon: icons.github, color: "#F05032" },
  { name: "React", startdate: "02-03-2025", icon: icons.react, color: "#61DAFB" },
  { name: "Figma", startdate: "02-03-2025", icon: icons.figma, color: "#F24E1E" },
];

const schoolHistory = [
  {
    period: "2023 - current",
    title: "Software Development (MBO niveau 4)",
    icon: icons.roc,
    place: "ROC van Twente, De Sumpel",
    description:
      "Currently in a Software Development study, getting experience in web development, programming languages, and software design.",
  },
  {
    period: "2019 - 2023",
    title: "VMBO GL/TL",
    icon: icons.canisius,
    place: "Canisius Tubbergen",
    description:
      "Completed VMBO GL/TL with slight focus on IT subjects. Didn't have much experience with programming but got a good general education and developed an interest for software development in the last year of school.",
  },
];

const workExperience = [
  {
    period: "2025-06-30 - 2026-06-30",
    title: "Part time Software Developer at Sellabees",
    icon: icons.sellabees,
    place: "Sellabees",
    description:
      "Started as an intern and developed and deployed a new POS system from concept to production, managing both customer-facing checkout operations and advanced backoffice functionality to streamline retail operations.",
  },
  {
    period: "2023 - 2025",
    title: "Kitchen Assistant at Shamrock Almelo",
    icon: icons.shamrock,
    place: "Shamrock Almelo",
    description:
      "Assisting in kitchen... Not any software related work.",
  },
];

const calculateStartDateToNow = (start) => {
  const startDate = new Date(start);
  const now = new Date();
  const diffInYears = (now - startDate) / (1000 * 60 * 60 * 24 * 365);
  const years = Math.floor(diffInYears);
  const months = Math.floor((diffInYears - years) * 12);
  return `${years > 0 ? `${years} yr ` : ""}${months} months`;
};

const openCV = () => {
  const newWindow = window.open(cv, "_blank");
  if (newWindow) newWindow.opener = null;
};

export default function Welcome() {
  const [activeTab, setActiveTab] = useState("work");
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  const switchTab = (tab) => {
    if (tab === activeTab) return;
    setVisible(false);
    setTimeout(() => {
      setActiveTab(tab);
      setVisible(true);
    }, 150);
  };

  return (
    <motion.div
      className="welcome-page"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={{ duration: 0.25 }}
    >
      <section className="hero" id="home">
        <div className="container hero-inner">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-dot" />
              Available for new opportunities
            </div>

            <h1 className="hero-title">
              Hi, I'm <span className="hero-name-accent">Jaylano</span>
            </h1>
            <h1 className="hero-title">Software Developer</h1>

            <p className="hero-description">
              Building responsive clean and modern websites! Always open to learn something new
            </p>

            <div className="hero-actions">
              <button className="btn-primary" onClick={() => openCV()}>
                Download CV
              </button>
              <button
                className="btn-outline"
                onClick={() => navigate("/contact")}
              >
                Contact me
              </button>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-n">20+</span>
                <span className="stat-l">Projects Done</span>
              </div>
              <div className="stat-item">
                <span className="stat-n">3 Years</span>
                <span className="stat-l">School experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-n">1 Year </span>
                <span className="stat-l">Work experience</span>
              </div>
            </div>
          </div>

          <div className="avatar-wrap">
            <div className="avatar-ring">
              <div className="avatar-inner">
                <img
                  src={icons.profilepicture}
                  alt="Jaylano van der Veen"
                  className="avatar-photo"
                />
              </div>
            </div>
            <div className="avatar-badge">
              <span className="status-dot" /> Open for work
            </div>
          </div>
        </div>
      </section>

      <section className="timeline-section" id="experience">
        <div className="container timeline-container">
          <h2 className="section-title">Background</h2>

          <div className="timeline-tabs">
            <button
              className={`tab-btn ${activeTab === "work" ? "tab-active" : ""}`}
              onClick={() => switchTab("work")}
            >
              Werkervaring
            </button>
            <button
              className={`tab-btn ${activeTab === "school" ? "tab-active" : ""}`}
              onClick={() => switchTab("school")}
            >
              Opleidingen
            </button>

          </div>

          <div className="timeline-wrapper">
            <div className={`timeline${visible ? "" : " timeline-hidden"}`}>
              {(activeTab === "school" ? schoolHistory : workExperience).map(
                (item, i, arr) => (
                  <div
                    className={`timeline-item${i === arr.length - 1 ? " last" : ""}`}
                    key={i}
                  >
                    <div className="timeline-dot" />
                    <div className="timeline-content">
                      {item.icon && (
                        <img
                          src={item.icon}
                          alt={item.title}
                          className="timeline-card-icon"
                        />
                      )}
                      <span className="timeline-period">{item.period}</span>
                      <h3 className="timeline-title">{item.title}</h3>
                      <span className="timeline-place">{item.place}</span>
                      <p className="timeline-desc">{item.description}</p>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </section>

      <section id="skills" className="skills-section">
        <div className="container">
          <h2 className="section-title">My Skills</h2>
          <div className="skills-grid">
            {skills.map((skill) => (
              <div className="skill-card fade-in" key={skill.name}>
                <div className="skill-icon">
                  <img src={skill.icon} alt={skill.name} className="skill-icon-img" />
                </div>
                <h3>{skill.name}</h3>
                <p>{calculateStartDateToNow(skill.startdate)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="projects" className="projects-section">
        <div className="container">
          <h2 className="section-title">Recent Projects</h2>
          <div className="projects-grid">
            <div className="project-card fade-in">
              <div className="project-header">SimpleMC</div>
              <p>
                I built a full Minecraft server from scratch: a wiki, a website, a Discord bot, and a Java plugin. The management panel supports one-click modpack installs, server monitoring, and automated backups.
              </p>
              <div className="tech-stack">
                <span className="tech">React</span>
                <span className="tech">PHP</span>
                <span className="tech">MySQL</span>
                <span className="link-to-simplemc"
                  onClick={() => window.open('https://simplemcnetwork.net', '_blank')}>View website</span>
              </div>

            </div>
            <div className="project-card fade-in">
              <div className="project-header">Portofolio</div>
              <p>
                You are currently looking at it! This portfolio website is built with React, featuring smooth animations, responsive, and a clean modern design to showcase my skills and projects effectively.
              </p>
              <div className="tech-stack">
                <span className="tech">React</span>
                <span className="tech">JavaScript</span>
                <span className="tech">CSS</span>
              </div>
            </div>
            <div className="project-card fade-in">
              <div className="project-header">Sparesort Bali (school project)</div>
              <p>
                For a school project I built a website for a spa-resort/lodge vendor in Bali. The site includes multiple user roles (customer, employee, owner) all fully functional with features like booking, reviews, and an admin dashboard..
              </p>
              <div className="tech-stack">
                <span className="tech">React</span>
                <span className="tech">PHP</span>
                <span className="tech">MySQL</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="contact-section">
        <div className="container">
          <div className="contact-box">
            <h2>Let's work together</h2>
            <p>
              I'm currently open to new opportunities and collaborations. Whether you have a project in mind or just want to connect, feel free to reach out!
            </p>
            <a href="mailto:jaylanovanderveen.work@gmail.com" className="btn-primary">
              ✉ Send me a message
            </a>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
